<ion-app>
  @if (state.isLoading) {
    <div class="flex h-full w-full items-center justify-center">
      <dojo-loader [size]="8"></dojo-loader>
    </div>
  } @else {
    <ion-router-outlet></ion-router-outlet>
  }
</ion-app>
